import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Problem as SchemaProblem } from '../schemas/Problem';
import { type SwitchCashierProblemType as SchemaSwitchCashierProblemType } from '../schemas/SwitchCashierProblemType';
import { type SwitchCashierRequest as SchemaSwitchCashierRequest } from '../schemas/SwitchCashierRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const SwitchCashierContentType = 'application/json' as const;
export type SwitchCashierRequest = SchemaSwitchCashierRequest;
export type SwitchCashierResponses = LinkCommonErrorResponses & {
    /**
     * @description Cashier switched successfully
     */
    '200': {};
    /**
     * @description Invalid input or validation error
     */
    '400': {
        'application/json': SchemaProblem & {
            type: SchemaSwitchCashierProblemType;
        };
    };
};
export type SwitchCashierResponseSuccess = undefined;
export type SwitchCashierSearchParams = undefined;
export type SwitchCashierPathParameters = undefined;
export const SwitchCashierUrl = '/integrations/cashiers' as const;
export const SwitchCashierMethod = 'PATCH' as const;
export const getSwitchCashierUrl = (_params?: SwitchCashierPathParameters) => SwitchCashierUrl;
